import {jobsApi} from '../jobs.api';
import {JobResult, JobUIStatus} from '../jobs.types';
import {INTERVAL_MS_DEFAULT} from '../jobs.consts';

async function waitForJobWithoutBGProcess<Result extends JobResult>({
  jobExecutionId,
  intervalMS = INTERVAL_MS_DEFAULT,
}: {
  jobExecutionId: number;
  intervalMS?: number;
}): Promise<{
  result: Result;
}> {
  return new Promise((resolve, reject) => {
    const interval = setInterval(async () => {
      try {
        const res = await jobsApi.getJobExecution<Result>(jobExecutionId);

        if (res.status === JobUIStatus.Completed) {
          clearInterval(interval);
          resolve({result: res.result});
        } else if ([JobUIStatus.Failed, JobUIStatus.Aborted].includes(res.status)) {
          throw res;
        }
      } catch (error) {
        clearInterval(interval);
        reject(error);
      }
    }, intervalMS);
  });
}

export default waitForJobWithoutBGProcess;
